import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';

const getCartCustomerStatus = (urls: any, domain: string, deviceCode: string, session: string, cartUid: string) => {
	const params = new URLSearchParams({cartUid})
	return client(urls.LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/customer/${session}/carts/customerstatus?${params.toString()}`);
}

// Whether the session customer is the customer on the cart; undefined until loaded.
export default function useGetCartCustomerStatus(urls: any, domain: string, deviceCode: string, session: string, cartUid: string, enabled: boolean) {
	const {status, data, refetch} = useQuery(['CartCustomerStatus', session, cartUid], () => getCartCustomerStatus(mapServiceUrls(urls), domain, deviceCode, session, cartUid), { enabled: urls && enabled && !!session && !!cartUid, staleTime: 1000*60*60 });
	const isSessionCustomer: boolean | undefined = data ? data.data?.IsSessionCustomer : undefined;
	return {customerStatus: status, isSessionCustomer, refetch};
}
